import 'catalog/components/CatalogFooter/CatalogFooter.scss';

import React from 'react';

import { Vehicle } from '@sm360/widget-commons-vehicle';

const CatalogFooter = () => {
    // Keeping this commented code just in case in future if we want to re-enable the disclaimer again
    // const genericDisclaimers = purchaseMethods &&
    //     purchaseMethods.disclaimers && [
    //         purchaseMethods.disclaimers.dataResponsibility,
    //         purchaseMethods.disclaimers.priceChange,
    //     ];
    return (
        <div className="catalog-footer">
            <div className="sr-disclaimer">
                <Vehicle.VehicleDisclaimersContent />
            </div>
        </div>
    );
};

CatalogFooter.propTypes = {
    // purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel).isRequired,
};

export default CatalogFooter;
